import { M6_UNIT_1 } from './Unit1';
import { M6_UNIT_2 } from './Unit2';
import { M6_UNIT_3 } from './Unit3';
import { M6_UNIT_4 } from './Unit4';
import { M6_UNIT_5 } from './Unit5';
import { M6_UNIT_6 } from './Unit6';
import { M6_UNIT_7 } from './Unit7';
import { M6_UNIT_8 } from './Unit8';
import { M6_UNIT_9 } from './Unit9';
import { M6_UNIT_10 } from './Unit10';
import { M6_UNIT_11 } from './Unit11';
import { M6_UNIT_12 } from './Unit12';
import { M6_UNIT_13 } from './Unit13';
import { M6_UNIT_14 } from './Unit14';
import { M6_UNIT_15 } from './Unit15';
import { M6_READING_PRACTICE } from './ReadingPractice';
import { M6_MODULE_REVIEW } from './UnitReview';

export const MODULE_6_UNITS = [
  M6_UNIT_1,
  M6_UNIT_2,
  M6_UNIT_3,
  M6_UNIT_4,
  M6_UNIT_5,
  M6_UNIT_6,
  M6_UNIT_7,
  M6_UNIT_8,
  M6_UNIT_9,
  M6_UNIT_10,
  M6_UNIT_11,
  M6_UNIT_12,
  M6_UNIT_13,
  M6_UNIT_14,
  M6_UNIT_15,
  M6_READING_PRACTICE,
  M6_MODULE_REVIEW
];
